// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f9656b","fullGame":"_b9eac28"};